import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M960.360699,0.011351476 L109,508.784505 L109,1411.22685 L960.360699,1920 L1811.83491,1411.22685 L1811.83491,508.784505 L960.360699,0.011351476 Z M222.51476,1346.86398 L222.51476,573.033859 L960.360699,132.142532 L1698.32015,573.033859 L1698.32015,1346.86398 L960.360699,1787.86882 L222.51476,1346.86398 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconShapePolygonLine = /*#__PURE__*/function (_Component) {
  _inherits(IconShapePolygonLine, _Component);

  var _super = _createSuper(IconShapePolygonLine);

  function IconShapePolygonLine() {
    _classCallCheck(this, IconShapePolygonLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconShapePolygonLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconShapePolygon",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconShapePolygonLine.displayName = "IconShapePolygonLine";
  return IconShapePolygonLine;
}(Component);

IconShapePolygonLine.glyphName = 'shape-polygon';
IconShapePolygonLine.variant = 'Line';
IconShapePolygonLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconShapePolygonLine;
export { IconShapePolygonLine };